import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.addEventListener('toast:show', this.show.bind(this))
  }

  disconnect() {
    window.removeEventListener('toast:show', this.show.bind(this))
  }

  show(event) {
    const { message, type = 'info' } = event.detail

    const toast = document.createElement('div')
    toast.className = this.getToastClasses(type)
    toast.innerHTML = `
      <div class="flex items-center gap-2">
        ${this.getIcon(type)}
        <span>${message}</span>
      </div>
    `

    this.element.appendChild(toast)

    // Auto-remove after 3 seconds
    setTimeout(() => {
      toast.classList.add('opacity-0', 'translate-x-full')
      setTimeout(() => toast.remove(), 300)
    }, 3000)
  }

  getToastClasses(type) {
    const baseClasses = 'px-4 py-3 rounded-lg shadow-lg mb-2 transition-all duration-300 transform'
    const typeClasses = {
      success: 'bg-green-500 text-white',
      error: 'bg-red-500 text-white',
      info: 'bg-blue-500 text-white',
      warning: 'bg-yellow-500 text-white'
    }

    return `${baseClasses} ${typeClasses[type] || typeClasses.info}`
  }

  getIcon(type) {
    const icons = {
      success: '✓',
      error: '✕',
      info: 'ℹ',
      warning: '⚠'
    }

    return `<span class="font-bold text-lg">${icons[type] || icons.info}</span>`
  }
}
